import { createSlice } from "@reduxjs/toolkit";
import {
  getAllSetsBuilder,
  getPublicSetByIdBuilder,
  getSetByIdBuilder,
  getMySetByIdBuilder,
  createSetBuilder,
  updateSetBuilder,
  deleteSetBuilder,
  getSetsStatisticsBuilder,
  getFeaturedSetsBuilder,
  exportSetsBuilder,
  importSetsBuilder,
} from "./builder";

const initialState = {
  sets: [],
  featuredSets: [],
  selectedSet: null,
  statistics: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
  filters: {
    search: "",
    status: "",
    featured: null,
  },
  loading: {
    getAllSets: false,
    getFeaturedSets: false,
    getSetById: false,
    getMySetById: false,
    createSet: false,
    updateSet: false,
    deleteSet: false,
    getSetsStatistics: false,
    exportSets: false,
    importSets: false,
  },
  errors: {
    getAllSets: null,
    getFeaturedSets: null,
    getSetById: null,
    getMySetById: null,
    createSet: null,
    updateSet: null,
    deleteSet: null,
    getSetsStatistics: null,
    exportSets: null,
    importSets: null,
  },
};

const setsSlice = createSlice({
  name: "sets",
  initialState,
  reducers: {
    clearErrors: (state) => {
      Object.keys(state.errors).forEach((key) => {
        state.errors[key] = null;
      });
    },
    clearSelectedSet: (state) => {
      state.selectedSet = null;
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {
        search: "",
        status: "",
        featured: null,
      };
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    getAllSetsBuilder(builder);
    getPublicSetByIdBuilder(builder);
    getSetByIdBuilder(builder);
    getMySetByIdBuilder(builder);
    createSetBuilder(builder);
    getFeaturedSetsBuilder(builder);
    updateSetBuilder(builder);
    deleteSetBuilder(builder);
    getSetsStatisticsBuilder(builder);
    exportSetsBuilder(builder);
    importSetsBuilder(builder);
  },
});

export const {
  clearErrors,
  clearSelectedSet,
  setFilters,
  clearFilters,
  setPagination,
} = setsSlice.actions;

// Selectors
export const selectSets = (state) => state.sets.sets;
export const selectSelectedSet = (state) => state.sets.selectedSet;
export const selectSetsStatistics = (state) => state.sets.statistics;
export const selectSetsPagination = (state) => state.sets.pagination;
export const selectSetsFilters = (state) => state.sets.filters;
export const selectSetsLoading = (state) => state.sets.loading;
export const selectSetsErrors = (state) => state.sets.errors;
export const selectGetSetByIdLoading = (state) => state.sets.loading.getSetById;
export const selectGetMySetByIdLoading = (state) =>
  state.sets.loading.getMySetById;
export const selectFeaturedSets = (state) => state.sets.featuredSets;
export const selectGetFeaturedSetsLoading = (state) =>
  state.sets.loading.getFeaturedSets;
export const selectGetFeaturedSetsErrors = (state) =>
  state.sets.errors.getFeaturedSets;
export const selectExportSetsLoading = (state) =>
  state.sets.loading.exportSets;
export const selectExportSetsError = (state) =>
  state.sets.errors.exportSets;
export const selectImportSetsLoading = (state) =>
  state.sets.loading.importSets;
export const selectImportSetsError = (state) =>
  state.sets.errors.importSets;

export default setsSlice.reducer;
